import AiSettingsTab from '../../components/AiSettingsTab';

const AiSettingsPage = () => {
  return <AiSettingsTab />;
};

export default AiSettingsPage;
